import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'
import { Button } from "monday-ui-react-core"

const RemoveUserModal = ({open, onConfirm, onClose, email, organizationName}) => {

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={false}
                maxWidth='lg'
            >
                <DialogTitle>Remove User</DialogTitle>
                <IconButton
                    aria-label='close'
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <p>Are you sure you want to remove user {email} from organization {organizationName}?</p>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button className="cancel" onClick={onClose} marginRight={2}>Cancel</Button>
                    <Button className="success" onClick={onConfirm} marginRight={2}>Save</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default RemoveUserModal